function syncQuickFilters() {
  const chips = document.querySelectorAll('.quick-filter-btn');
  const checkboxes = document.querySelectorAll(
    'input[name="filter.p.product_type"]'
  );

  chips.forEach(chip => {
    const label = chip.textContent.trim();
    let isActive = false;

    checkboxes.forEach(cb => {
      if (cb.value === label && cb.checked) {
        isActive = true;
      }
    });

    chip.classList.toggle('active', isActive);
  });
}

// לחיצה על בועה
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.quick-filter-btn');
  if (!btn) return;

  const label = btn.textContent.trim();

  const checkboxes = document.querySelectorAll(
    'input[name="filter.p.product_type"]'
  );

  checkboxes.forEach(cb => {
    if (cb.value === label) {
      cb.click();
    }
  });
});

// סנכרון בהטענה ראשונית
document.addEventListener('DOMContentLoaded', syncQuickFilters);

// סנכרון אחרי כל שינוי פילטר (AJAX של Shopify)
document.addEventListener('change', function (e) {
  if (e.target.name === 'filter.p.product_type') {
    setTimeout(syncQuickFilters, 50);
  }
});
